import * as Sentry from '@sentry/browser'

const DEFAULT_MESSAGE = 'Checkout builder log'

export default (payload = {}) => {
  if (process.env.NODE_ENV === 'development') return

  const { error, level, action, ...extra } = payload
  const isException = error instanceof Error

  const context = {
    tags: { source: 'checkout-builder', ...(action ? { action } : {}) },
    extra: isException || error === undefined ? extra : { ...extra, error }
  }

  if (isException) {
    Sentry.captureException(error, context)
    return
  }

  Sentry.captureMessage(action || DEFAULT_MESSAGE, {
    ...context,
    level: (level || 'error').toLowerCase()
  })
}
